module.exports = __webpack_public_path__ + "img/fille.1957a7e5.png";